import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider
} from '@mui/material';

/**
 * TTL Download confirmation dialog
 */
const TTLDownloadDialog = ({ 
  open, 
  file, 
  onConfirm, 
  onClose, 
  hasPermission = true 
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Summary</DialogTitle>
      <DialogContent>
        {hasPermission ? (
          <Typography variant="body1" gutterBottom>
            Do you want to download the Excel file for{' '}
            <strong>{file?.name}</strong>?
          </Typography>
        ) : (
          <Typography color="error" variant="body1">
            You do not have permission to download this file.
          </Typography>
        )}
        {file && file.total_requirements !== undefined && (
          <>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ mt: 2 }}>
              <Typography variant="h6" gutterBottom>
                Document Statistics:
              </Typography>
              
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body1" color="text.secondary">
                    Total Requirements:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {file.total_requirements}
                  </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body1" color="text.secondary">
                    Validated Requirements:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" color="success.main">
                    {file.validated_count} ({file.validated_percentage}%)
                  </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body1" color="text.secondary">
                    SMART Analyzed Requirements:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" color="primary.main">
                    {file.smart_analyzed_count} ({file.smart_percentage}%)
                  </Typography>
                </Box>
              </Box>
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained">
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TTLDownloadDialog;
